import script from "./AppTabsBody.vue?vue&type=script&lang=tsx"
export * from "./AppTabsBody.vue?vue&type=script&lang=tsx"

import "./AppTabsBody.vue?vue&type=style&index=0&id=00d3df36&scoped=true&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00d3df36"]])

export default __exports__